<template>
  <div v-if="visible" class="youth-prompt-overlay">
    <div class="youth-prompt-dialog">
      <div class="prompt-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
      </div>
      <h3>未成年人保护提示</h3>
      <p class="prompt-text">
        根据《未成年人网络保护条例》，本平台提供青少年模式：
        开启后将限制使用时长与夜间时段、过滤不适宜内容、并禁止充值消费。
        建议未成年人用户在监护人指导下开启。
      </p>
      <div class="prompt-actions">
        <button class="prompt-btn-secondary" @click="dismiss">我知道了</button>
        <button class="prompt-btn-primary" @click="goYouthMode">开启青少年模式</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getYouthConfig } from '@/api/index';

export default {
  name: 'YouthModePrompt',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    // 阅读器与设置页内不弹，避免打断阅读/操作
    const path = this.$route.path || '';
    if (path.startsWith('/reader') || path.startsWith('/youth-mode')) return;
    this.$nextTick(() => {
      setTimeout(() => this.maybeShow(), 1200);
    });
  },
  methods: {
    async maybeShow() {
      // 每天最多提示一次
      const today = new Date().toISOString().slice(0, 10);
      if (localStorage.getItem('youthPromptDate') === today) return;

      // 已登录且已开启青少年模式的用户不再提示
      const token = localStorage.getItem('userToken');
      if (token) {
        try {
          const res = await getYouthConfig();
          if (res.data && res.data.code === 1 && res.data.data.enabled) {
            localStorage.setItem('youthPromptDate', today);
            return;
          }
        } catch (e) {
          // 查询失败时仍提示，确保保护信息可见
        }
      }

      this.visible = true;
    },
    dismiss() {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem('youthPromptDate', today);
      this.visible = false;
    },
    goYouthMode() {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem('youthPromptDate', today);
      this.visible = false;
      // 未登录时路由守卫会引导先登录
      this.$router.push('/youth-mode');
    },
  },
};
</script>

<style scoped>
.youth-prompt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(5, 14, 26, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
  padding: 20px;
}

.youth-prompt-dialog {
  width: 100%;
  max-width: 420px;
  background: linear-gradient(180deg, #14283f 0%, #0d1a2b 100%);
  border: 1px solid rgba(96, 165, 250, 0.3);
  border-radius: 18px;
  padding: 28px 26px 24px;
  text-align: center;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.6);
}

.prompt-icon {
  width: 54px;
  height: 54px;
  margin: 0 auto 14px;
  color: #4facfe;
}

.prompt-icon svg {
  width: 100%;
  height: 100%;
}

.youth-prompt-dialog h3 {
  margin: 0 0 10px;
  font-size: 19px;
  color: #fff;
  font-weight: 700;
}

.prompt-text {
  font-size: 13.5px;
  line-height: 1.8;
  color: rgba(226, 240, 252, 0.78);
  margin: 0 0 22px;
  text-align: left;
}

.prompt-actions {
  display: flex;
  gap: 12px;
}

.prompt-btn-secondary,
.prompt-btn-primary {
  flex: 1;
  padding: 11px 0;
  border-radius: 10px;
  font-size: 14.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.prompt-btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(232, 244, 252, 0.85);
}

.prompt-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.14);
}

.prompt-btn-primary {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
  color: #fff;
  box-shadow: 0 4px 14px rgba(79, 172, 254, 0.4);
}

.prompt-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(79, 172, 254, 0.55);
}
</style>
